import { call, put, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import signInActions, { setSignInPending } from './actions'
import api from '../../utils/api'
import { setVisit, setVisitWorkOrder } from '../visit/actions'
import { setSiteWorkOrders } from '../workorders/actions'
import { sendMessage } from '../../utils/appHelper'

const queryCloseProperties = (lat, lon) => call(api.getClosestProperties, lat, lon)
const queryGeofenceRadius = () => call(api.getGeofenceRadius)
const queryWorkOrdersRequired = employerId => call(api.areWorkOrdersRequried, employerId)
const getWorkOrdersByProperty = (siteCode, siteType) => call(api.getWorkOrdersBySite, siteCode, siteType)
const performSignIn = details => call(api.signIn, details)


const getProperty = state => state.sainsburysSites.site
const getDeviceType = state => state.device.deviceType
const getEmployerId = state => state.loggedInUser.user.employerId
const getRAMSDecline = state => state.signIn.ramsdecline

function* signIn(action) {
  yield put(setSignInPending(true))

  try {
    const properties = yield queryCloseProperties(action.latitude, action.longitude)
    const signInProperty = yield select(getProperty)

    if (!properties) { // no properties found in current location
      yield put({ type: signInActions.setSignIn, status: { hasWarning: true, statusText: 'You are not close to any sites.' } })
      yield put(push('/SignIn'))
    } else if (properties.findIndex(p => p.code === signInProperty.code
      && p.propertyType === signInProperty.propertyType) === -1) { // signin property is not in current location
      yield put({ type: signInActions.setSignIn, status: { hasWarning: true, statusText: 'Your location has changed. Please try again.' } })
      yield put(push('/SignIn'))
    } else {
      const deviceType = yield select(getDeviceType)

      const ramsDecline = yield select(getRAMSDecline)
      console.log(ramsDecline)

      const details = {
        siteId: signInProperty.code,
        siteName: signInProperty.name,
        deviceType,
        latitude: signInProperty.latitude,
        longitude: signInProperty.longitude,
        signedInSiteTypeId: signInProperty.siteType,
        ramsDecline
      }

      const signInResult = yield performSignIn(details)

      if (ramsDecline == 'Decline') {
        yield put(push('/RAMSDecline'))
      } else if (signInResult !== null && signInResult !== undefined) {
        if (signInResult === 0) {
          yield put({ type: signInActions.setSignIn, status: { alreadySignedIn: true, statusText: 'You are already signed in. Please sign out.' } })
        } else {
          yield put(setVisit({ id: signInResult, visitPasses: [] }))
          const radius = yield queryGeofenceRadius()

          const storeDetails = {
            storeId: signInProperty.code,
            storeName: signInProperty.name,
            latitude: signInProperty.latitude,
            longitude: signInProperty.longitude,
            radius
          }
          sendMessage('signIn', storeDetails)

          const employerId = yield select(getEmployerId)
          const workOrdersRquired = yield queryWorkOrdersRequired(employerId)

          if (!workOrdersRquired || signInProperty.siteType === 'Depot') {
            yield put(push({
              pathname: '/confirmation',
              state: { signIn: true }
            }))
          } else {
            const workOrders = yield getWorkOrdersByProperty(signInProperty.code, signInProperty.siteType)
            if (workOrders.length === 0) {
              yield put(setVisitWorkOrder(null))
              yield put(setSiteWorkOrders([]))
              yield put(push('/WorkOrderHome'))
            } else {
              yield put(setSiteWorkOrders(workOrders))
              yield put(push('workorders/false'))
            }
          }
        }
      }
    }
  } finally {
    yield put(setSignInPending(false))
  }
}


export default signIn
